<template>
  <div>
    <label
      v-if="this.label.length > 0"
      class="body3"
      style="margin-left: 1px; margin-bottom: 10px"
      :for="$attrs.id ? $attrs.id : ''"
    >
      {{ this.label
      }}<span v-if="this.required != false && this.required != ''">*</span
      ><b-icon
        v-if="this.icon && this.icon != false"
        style="margin-left: 8px"
        icon="question-circle"
      />
    </label>
    <div class="text-field-input">
      <vSelect
        class="income-select"
        v-on="$listeners"
        v-bind="$attrs"
        :clearable="false"
        :unselectable="unselectable"
        label="name"
        @search:focus="searchFocused"
      >
        <template
          v-if="$attrs.multiple"
          #selected-option-container="defaultObj"
        >
          <div class="vs__selected">
            <div>{{ defaultObj.option.option.name }}</div>
            <button
              @click.prevent="defaultObj.deselect(defaultObj.option.option)"
              type="button"
              title="Deselect Option A (from options prop)"
              aria-label="Deselect Option A (from options prop)"
              class="vs__deselect"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.878 1.12212C10.7999 1.044 10.6939 1.00012 10.5834 1.00012C10.4729 1.00012 10.367 1.044 10.2888 1.12212L6 5.41094L1.71117 1.12212C1.63304 1.044 1.52707 1.00012 1.41659 1.00012C1.3061 1.00012 1.20013 1.044 1.122 1.12212C1.04388 1.20026 1 1.30622 1 1.41671C1 1.52719 1.04388 1.63316 1.122 1.7113L5.41082 6.00012L1.122 10.2889C1.04388 10.3671 1 10.4731 1 10.5835C1 10.694 1.04388 10.8 1.122 10.8781C1.20013 10.9562 1.3061 11.0001 1.41659 11.0001C1.52707 11.0001 1.63304 10.9562 1.71117 10.8781L6 6.5893L10.2888 10.8781C10.367 10.9562 10.4729 11.0001 10.5834 11.0001C10.6939 11.0001 10.7999 10.9562 10.878 10.8781C10.9561 10.8 11 10.694 11 10.5835C11 10.4731 10.9561 10.3671 10.878 10.2889L6.58918 6.00012L10.878 1.7113C10.9561 1.63316 11 1.52719 11 1.41671C11 1.30622 10.9561 1.20026 10.878 1.12212Z"
                  fill="#0C2D45"
                  fill-opacity="0.8"
                />
              </svg>
            </button>
          </div>
        </template>

        <template v-if="withCheckbox" #option="{ option, extra }">
          <div class="multiselect__option">
            <div class="multiselect__checkbox">
                <BFormCheckbox size="sm" :checked="extra.isOptionSelected(option)"></BFormCheckbox>
            </div>
            <div>{{ option.name }}</div>
            <!-- {{ value }} -->
          </div>
        </template>

        <template v-else #option="{ option }">
          <div class="multiselect__option">{{ option.name }}</div>
        </template>
      </vSelect>

      <b-icon-question-circle style="display: none"></b-icon-question-circle>
    </div>
  </div>
</template>
<script>
import vSelect from './extra/vue-select'

import { BIcon, BIconQuestionCircle, BFormCheckbox } from 'bootstrap-vue'
export default {
  name: 'SelectField',
  components: {
    BFormCheckbox,
    BIcon,
    BIconQuestionCircle,
    vSelect
  },
  props: {
    required: Boolean,
    icon: Boolean,
    label: String,
    unselectable: {
      type: Boolean,
      default: true
    },
    withCheckbox: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: []
    }
  },
  mounted() {},
  methods: {
    searchFocused() {
      // alert('yes');
    }
  }
}
</script>
